export default __webpack_public_path__ + "static/teamPhoto2-1baa7ef375b02b4154c2568876cc3aa1.png";